import script from "./TopEntitiesTable.vue?vue&type=script&lang=ts&setup=true"
export * from "./TopEntitiesTable.vue?vue&type=script&lang=ts&setup=true"

import "./TopEntitiesTable.vue?vue&type=style&index=0&id=02ed7efa&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-02ed7efa"]])

export default __exports__